import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { ITransaction } from "../../../../types/transactions";

export interface CsvTransactionInput {
  amount: number;
  paymentDate: string;
  currency: string;
  name?: string;
  iban?: string;
  description?: string;
}

export interface BulkCreateCsvTransactionsMutationVariables {
  email: string;
  transactions: CsvTransactionInput[];
}

export interface BulkCreateCsvTransactionsMutationResult {
  bulkCreateCsvTransactions: ITransaction[];
}

export const BULK_CREATE_CSV_TRANSACTIONS_MUTATION = gql`
  mutation BulkCreateCsvTransactions(
    $email: String!
    $transactions: [ExternalTransactionInput!]!
  ) {
    bulkCreateCsvTransactions(email: $email, transactions: $transactions) {
      id
      amount
      valutaDate
      name
      iban
      description
      source
    }
  }
`;

export const useBulkCreateCsvTransactionsMutation = (
  options?: MutationHookOptions<
    BulkCreateCsvTransactionsMutationResult,
    BulkCreateCsvTransactionsMutationVariables
  >
) =>
  useMutation<
    BulkCreateCsvTransactionsMutationResult,
    BulkCreateCsvTransactionsMutationVariables
  >(BULK_CREATE_CSV_TRANSACTIONS_MUTATION, options);
